import React from 'react'
import { useQuery } from 'react-query'
import { useLocalStorage } from 'react-use'
import { useLocalStorageState } from 'ahooks'
import { getUserInfo } from '../api/auth-api'
import { useGetUserTestZones } from './TestZones'
import { fetchUsers } from '../api/users-api'

const KEY = 'user-info'

export const useUserInfo = () => {
  const {
    status,
    data: userInfo,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    [KEY],
    async () => {
      return await getUserInfo()
    },
    {
      refetchOnWindowFocus: false,
    },
  )
  return {
    status,
    userInfo,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  }
}

export const useUserPlant = () => {
  const { isSuccess, isLoading, userInfo } = useUserInfo()
  const [userPlant, setUserPlant] = useLocalStorageState('user-plant', {
    defaultValue: null,
    listenStorageChange: true,
  })

  React.useEffect(() => {
    if (userPlant == null) {
      setUserPlant(userInfo?.plants[0]) // default plant
    }
  }, [userInfo, isSuccess, userPlant, setUserPlant])

  return [userPlant, setUserPlant]
}

export const useUserTestZones = () => {
  const [userPlant] = useUserPlant()
  const storageKey = `user-testzone-plant-${userPlant}`
  const [userTestZones, setUserTestZones] = useLocalStorageState(storageKey, {
    defaultValue: [],
    listenStorageChange: true,
  })

  return [userTestZones, setUserTestZones]
}

export const useGetUsers = () => {
  const {
    status,
    data: users,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    ['fetch-users'],
    async () => {
      let paginationToken = ''
      let users = []
      while (paginationToken !== null) {
        const res = await fetchUsers({ pagination: paginationToken })
        users = users.concat(res.users)
        paginationToken = res.pagination_token
      }
      return users
    },
    {
      refetchOnWindowFocus: false,
    },
  )
  return {
    status,
    users,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  }
}
